var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfoPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17c1.029 0 1.996-.197 2.901-.59.906-.394 1.703-.935 2.392-1.625.69-.689 1.23-1.485 1.62-2.388.392-.902.587-1.868.587-2.897 0-1.029-.195-1.995-.586-2.897-.391-.903-.933-1.7-1.625-2.392s-1.49-1.234-2.395-1.625C9.488 2.196 8.52 2 7.492 2c-1.018 0-1.98.195-2.886.586-.905.391-1.703.933-2.395 1.625S.977 5.7.586 6.603C.196 7.505 0 8.47 0 9.5c0 1.029.197 1.995.59 2.897.394.903.935 1.7 1.625 2.388.689.69 1.486 1.231 2.391 1.625.906.393 1.87.59 2.894.59zm0-1.381c-.844 0-1.636-.158-2.377-.475-.74-.316-1.39-.753-1.948-1.311-.558-.559-.994-1.208-1.308-1.949-.314-.74-.47-1.535-.47-2.384 0-.844.156-1.636.47-2.377.314-.74.75-1.391 1.308-1.952.558-.56 1.206-.999 1.945-1.315.738-.317 1.529-.475 2.372-.475.854 0 1.65.158 2.388.475.739.316 1.388.755 1.949 1.315.56.561.999 1.212 1.315 1.952.317.741.475 1.533.475 2.377.005.849-.152 1.644-.47 2.384-.32.741-.757 1.39-1.313 1.949-.555.558-1.203.995-1.944 1.311-.74.317-1.538.475-2.392.475zm0-4.854c.39 0 .592-.205.602-.617l.108-3.665c.005-.206-.062-.374-.2-.505-.14-.132-.312-.197-.518-.197-.216 0-.39.064-.524.193-.134.128-.198.296-.193.501l.1 3.68c.01.407.219.61.625.61zm0 2.4c.221 0 .414-.074.579-.224.164-.149.247-.334.247-.555 0-.227-.083-.414-.247-.563-.165-.15-.358-.224-.579-.224-.231 0-.427.076-.586.227-.16.152-.24.339-.24.56 0 .216.081.4.243.552.162.151.357.227.583.227z",
    transform: "translate(-16 -256) translate(16 254)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoPurple);
export default __webpack_public_path__ + "static/media/ic_info_purple.1bfdf566f65c487214e737b46118b29e.svg";
export { ForwardRef as ReactComponent };